import styled from 'styled-components';

export const PrivacySettingsStyles = styled.div`

  .paperStyles {
    padding: 1.5rem;
  }

  .priavcyButtonsSection {
    @media (max-width: 738px) {
      justify-content: flex-start;
    }
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 1.25rem 0.75rem;
    overflow-y: hidden;
    overflow-x: scroll;
    

    .privacyButton {
      display: block;
      margin: 0.5rem;
      min-width: 12rem !important;
      min-height: 12rem !important;
      
    }

    .privacyIcon {
      transition: all 0.5s ease;
      svg {
        transform: scale(2.35) !important;
        opacity: 0.25;
      }
    }

    .privacyIconHighlighted {
      transition: all 0.5s ease;
      
      svg {
        transform: scale(3.2) !important;
        opacity: 1;
        fill: white !important;
      }
    }

    .privacyText {
      position: relative;
      bottom: -2rem;
      text-transform: uppercase;
      letter-spacing: 0.05rem;
      line-height: 1.45rem;
      font-size: 1.25rem;
      display: block;
    }
  }

  .section {
    background: rgba(0, 0, 0, 0.035);
    border-radius: 0.5rem;
    padding: 0.25rem 0.75rem;
    margin: 0.5rem 0rem;
    .sectionTitle {
      font-size: 1.3rem;
      letter-spacing: 0.15rem;
      opacity: 0.5;
      text-transform: uppercase;
      margin: 0.75rem 0rem 0rem 0.75rem;
    }
  }
  
  .specificGroupsSection {
    padding: 0.75rem;
    .scrollContainer {
      margin: 1rem 0.25rem;
      max-height: 22rem;
      border-radius: 0.5rem;
      padding: 0.75rem;
      overflow: scroll;
      background: rgba(0, 0, 0, 0.03);
    }
    .listItemsWrapper {
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 0.5rem;
      padding: 0.75rem;
      background: white;
      margin: 0.2rem 0rem 0.5rem 0rem;
    }
    .listTitle {
      font-size: 1.25rem;
      margin-bottom: 0.75rem;
    }

    .listItem {
      width: 100% !important;
      transition: all 0.5s ease;
    }
    .unchecked {
      background: hsla(43, 85%, 50%, 0);
      transition: all 0.5s ease;
    }
    .checked {
      background: hsla(43, 85%, 50%, 0.2);
      transition: all 0.5s ease;
      padding-left: 1%;
    }
    .relationshipChip {
      margin: 0rem 0.15rem;
      cursor: pointer !important;
    }
    .listItemDetails {
      display: block;
    }
    .listItemDivider {
      width: 100%;
      opacity: 0.75 !important;
      margin-left: 0rem !important;
    }
  }
`;
